module.exports = __webpack_public_path__ + "media/img/printer-0ee318d8b68840b24edd6f4a17e63b14.jpg";